import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsKodingComponent } from './simple-icons-koding.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsKodingComponent ],
    exports:      [ SimpleIconsKodingComponent ],
    bootstrap:    []
})
export class SimpleIconsKodingModule {}
